import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/user/get",
    method: "post",
    data,
  });
}
// 添加
export function addItem(data) {
  return request({
    url: "/api/user/add",
    method: "post",
    data,
  });
}
// 编辑
export function editItem(id, data) {
  return request({
    url: "/api/user/update",
    method: "post",
    data: { id, ...data },
  });
}
// 删除
export function delItem(data) {
  return request({
    url: "/api/user/delete",
    method: "post",
    data,
  });
}
